import { module } from 'angular';
import templateBuilderMfDisplay from './builder/display.html';
import templateBuilderMfData from './builder/data.html';
import templateBuilderMfKtable from './builder/ktable.html';
import templateBuilderMfValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/mf/display.html', templateBuilderMfDisplay);
	$templateCache.put('kform/components/mf/data.html', templateBuilderMfData);
	$templateCache.put('kform/components/mf/ktable.html', templateBuilderMfKtable);
	$templateCache.put('kform/components/mf/validate.html', templateBuilderMfValidate);
});
